"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M22.667 12.999c0 5.891-4.776 10.666-10.667 10.666S1.333 18.89 1.333 13C1.333 7.107 6.11 2.332 12 2.332S22.667 7.107 22.667 13ZM12 24.999c6.628 0 12-5.372 12-12s-5.372-12-12-12-12 5.372-12 12c0 6.627 5.372 12 12 12Zm.276-6.418a1.429 1.429 0 1 0 2.02-2.02l-3.36-3.36a.286.286 0 0 1 0-.403l3.36-3.36a1.429 1.429 0 1 0-2.02-2.02L7.704 11.99a1.429 1.429 0 0 0 0 2.02l4.572 4.571Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};